// Redux
import { useAppSelector } from '@global/store/hooks';
import { subscriptionSelector } from '@global/store/slices/subscription/selectors';

import { useTranslation } from 'react-i18next';
import { buildTitleWithName } from '@global/utils/lang';
import { LOCALE_CODES } from '@global/types/types';

export const NotActive = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language as LOCALE_CODES;
  const { subscriptionsByUid } = useAppSelector(subscriptionSelector);

  const name =
    subscriptionsByUid[Object.keys(subscriptionsByUid)[0]]?.billingInfo?.name;

  return (
    <div className="no-sub">
      <div className="no-sub__info-wrapper">
        <span className="no-sub__title">
          {buildTitleWithName({
            name,
            locale,
            title: t('subDetails.pendingSub.title'),
          })}
        </span>
        <span className="no-sub__message">
          {t('subDetails.pendingSub.message')}
        </span>
      </div>
    </div>
  );
};
